import { SECTION_TYPES, ALIGNMENTS } from '../../models/InfoAndQuestions';

class InfoAndQuestionsSerializer {
  static deSerializeAlignment(alignment) {
    switch (alignment) {
      case 'L':
        return ALIGNMENTS.left;
      case 'C':
        return ALIGNMENTS.center;
      case 'R':
        return ALIGNMENTS.right;
      default:
        return null;
    }
  }

  static buildInformation(section) {
    return {
      type: SECTION_TYPES.information,
      order: section.Orden,
      label: section.Etiqueta,
      description: section.Descripcion,
      descriptionAlignment: InfoAndQuestionsSerializer
        .deSerializeAlignment(section.DescripcionAlign),
      boldDescription: section.DescripcionBold,
      italicDescription: section.DescripcionItalic,
      underlineDescription: section.DescripcionUnderline,
    };
  }

  // Remove questions with value zero because those should not
  // be shown.
  //
  // The value sent by the API is what indicates the order in which
  // those questions should be shown.
  static buildQuestions(questionsHash) {
    const questions = Object.keys(questionsHash).filter(question => questionsHash[question] > 0);
    return questions.map(question => ({
      type: SECTION_TYPES.question,
      order: questionsHash[question],
      question,
    }));
  }

  static buildSections(data) {
    const informationSections = (data.Lineas || [])
      .map(InfoAndQuestionsSerializer.buildInformation);
    const questions = InfoAndQuestionsSerializer.buildQuestions({
      acceptQuestion: data.PedirAceptaPresupuesto || null,
      cancelQuestion: data.PedirNoAceptaPresupuesto || null,
      disposalQuestion: data.PreguntarDisposición || null,
      regretQuestion: data.PreguntarMeArrepentí || null,
      oneWeekQuestion: data.PreguntarRetiro1Semana || null,
    });
    return informationSections.concat(questions);
  }

  static deSerialize(data) {
    return {
      error: data.ErrorInfo || null,
      serviceId: data.ServicioID || null,
      sections: InfoAndQuestionsSerializer.buildSections(data),
      title: data.Titulo || null,
    };
  }
}

export { InfoAndQuestionsSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/InfoAndQuestionsSerializer.js